<template>
    <div class="account">
        <br />

        <div class="center">金蝶引入</div>

        <br />

        <div class="center" style="color: red">下载模板后，根据模板提示填入相关信息，然后点击批量引入</div>

        <br />
        <div class="center">
            <k3-upload-tool obj="uploadExpressInfo" name="引入物流信息" :token="token"></k3-upload-tool>
        </div>
    </div>
</template>
<script>
import k3UploadTool from '@/components/common/K3Upload.vue';

export default {
    inject: ['reload'],
    components: {
        k3UploadTool
    },
    name: 'k3Upload',
    data() {
        return {
            loading: true,
            token: ''
        };
    },
    beforeMount() {},
    mounted() {
        this.token = this.$route.query.token;
    },
    watch: {
        $route(to, from) {
            this.token = this.$route.query.token;
            this.reload();
        }
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
.center {
    text-align: center;
}
</style>